
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#576766","stroke-miterlimit":"10","stroke-width":"2","d":"M13 4a9 9 0 100 18 9 9 0 100-18z"}}),_c('path',{attrs:{"fill":"none","stroke":"#576766","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"2","d":"M26 26l-6.563-6.563"}})])
          )
        }
      }
    